import { AxiosInstance } from 'axios'
import { StorybookTemplate, StorybookTemplateSummary } from './types'
import {
  GetHashesForBaseImages,
  GetImagesForPreview,
  GetImagesForPreviewResponse,
  GetPhotoProductAndVariants,
  PhotoProduct,
} from './types/photoProducts'

export class PhotoProductsApi {
  api: AxiosInstance

  constructor(api: AxiosInstance) {
    this.api = api
  }

  getPhotoProductAndVariants: GetPhotoProductAndVariants = async (photoProductId: number) => {
    const { data } = await this.api.get<PhotoProduct>(`/v1/photo-products/${photoProductId}`)

    return data
  }

  getHashesForBaseImages: GetHashesForBaseImages = async (variantId: number) => {
    const { data } = await this.api.get<string[]>(`/v1/printify/baseImageHash/${variantId}`)
    return data
  }
  getImagesForPreview: GetImagesForPreview = async (payload) => {
    const {
      data: { productId, images },
    } = await this.api.post<GetImagesForPreviewResponse>(
      `/v1/photo-products/generate-preview`,
      payload
    )

    return {
      images,
      productId,
    }
  }

  getStorybookTemplates = async (): Promise<StorybookTemplateSummary[]> => {
    const { data } = await this.api.get<StorybookTemplateSummary[]>('/v1/storybook-templates')
    return data
  }

  getStorybookTemplate = async (id: number): Promise<StorybookTemplate> => {
    const { data } = await this.api.get<StorybookTemplate>(`/v1/storybook-templates/${id}`)
    return data
  }
}
